import { Box, Grid } from "@mui/material";
import AppDialog from "../../../components/Common/AppDialog";
import ImportantNotice from "../../../components/Common/ImportantNotice";
import Label from "../../../components/Common/Label";
import Helpers from "../../../helpers/helpers";
import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import CustomButton from "../../../components/Form/CustomButton";

export default function BoostAdvert({ open, close, handleSubmit, advertData, setRenewOpen, windowWidth, userCreditBalance }) {
    const [boostInfoOpen, setBoostInfoOpen] = React.useState(false);
    const [confirmBoostOpen, setConfirmBoostOpen] = React.useState(false);

    const handlePositivePress = () => {
        if (advertData?.remaining_boosters > 0) {
            setConfirmBoostOpen(true);
        } else {
            close();
        }
    }

    return (
        <React.Fragment>
            <AppDialog
                title={'Boost this Advert'}
                open={open}
                close={close}
                positiveTitle={advertData?.remaining_boosters > 0 ? 'Boost now' : 'Close'}
                positivePress={() => handlePositivePress()}
                cancelButton={advertData?.remaining_boosters > 0 ? true : false}
                width={'50%'}
                isMobile={windowWidth <= 768}
            >
                <Grid container >
                    <Grid item lg={2} md={2} sm={12} xs={12} className="">
                        <img src={advertData?.images?.find((item) => item?.type === 'thumbnail')?.base64 || Helpers?.noImage} style={{ width: '100%', height: 80, objectFit: 'contain' }} />
                    </Grid>
                    <Grid item lg={10} md={10} sm={12} xs={12} px={1} className="d-flex align-items-center">
                        <div>
                            <div className="text-bold font-size-18">{advertData?.info?.title || ''}</div>
                            <div className="d-flex align-items-center">
                                <Label.GeneralStatusLabel label={advertData?.status} list={Helpers.advertStatus} marginLeft={"0px"} />
                                <Label.CustomLabel label={advertData?.advert_plan?.title || '-'} borderRadius={5} backgroundColor={'#B48A3C33'} color={'#B48A3C'} marginLeft={5} marginRight={5} />
                                <div className="d-flex">
                                    <span className="subheader-2" style={{ marginRight: 5 }}>Remaining Boosts: </span>
                                    {advertData?.remaining_boosters || 0}/3
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} >
                    <Grid item lg={6} md={12} sm={12} xs={12}>
                        <div className="subheader-2 d-flex align-items-center">
                            Boost Duration
                            <div className="mx-1 clickable d-flex align-items-center" onClick={() => { setBoostInfoOpen(true) }}>
                                <Icon icon={'solar:info-circle-linear'} />
                            </div>
                        </div>
                    </Grid>
                    <Grid item className="text-bold" lg={6} md={12} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }}>
                        {advertData?.boost_duration || 0} Days
                    </Grid>
                    <Grid item lg={6} md={12} sm={12} xs={12}>
                        <div className="subheader-2">
                            Your Available Credits
                        </div>
                    </Grid>
                    <Grid item className="text-bold" lg={6} md={12} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }}>
                        {userCreditBalance || 0} Credits
                    </Grid>
                    <Grid item lg={6} md={12} sm={12} xs={12}>
                        <div className="subheader-2">
                            Credits Required:
                        </div>
                    </Grid>
                    <Grid item className="text-bold" lg={6} md={12} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' }, color: '#34C759' }}>
                        {advertData?.credit_required || 0} Credits
                    </Grid>
                </Grid>
                {
                    (!advertData?.remaining_boosters || advertData?.remaining_boosters <= 0 || userCreditBalance < advertData?.credit_required) &&
                    <div className="my-2">
                        <ImportantNotice
                            iconName={'solar:danger-triangle-linear'}
                            iconColor={'#1D1B1B'}
                            backgroundColor={'#F4C06D33'}
                            color={'#F4C06D'}
                            message={
                                <>
                                    <div className="text-semibold">{userCreditBalance < advertData?.credit_required ? 'Insufficient Credits' : 'You have no boosts left'}</div>
                                    {userCreditBalance < advertData?.credit_required ? 'You do not have enough credits to boost this advert.' : 'You have reached the maximum number of boosts allowed under your advert plan.'}
                                    {
                                        userCreditBalance < advertData?.credit_required &&
                                        <>
                                            <Box className="mt-3 align-items-center" sx={{ display: { lg: 'flex', md: 'block' }, marginTop: { md: 2, sm: 2, xs: 2 } }}>
                                                <CustomButton
                                                    title={'Purchase credits'}
                                                    press={() => { setRenewOpen(true) }}
                                                    marginRight={10}
                                                />
                                                <CustomButton
                                                    title={'Dismiss'}
                                                    press={() => { }}
                                                    backgroundColor={'#F9F9F9'}
                                                    textColor={'#1D1B1B'}
                                                    borderStyle={'1px solid #F9F9F9'}
                                                />
                                            </Box>
                                        </>
                                    }
                                </>
                            }
                        />
                    </div>
                }
            </AppDialog>
            <AppDialog
                title={'How Boosting Works'}
                open={boostInfoOpen}
                close={() => setBoostInfoOpen(false)}
                positiveTitle={'Close'}
                positivePress={() => { setBoostInfoOpen(false) }}
                width={'40%'}
            >
                <ul className="subheader-2" style={{ padding: 5, paddingInline: 10 }}>
                    <li className="mb-2">Your advert jumps to the top of listing pages for the next 72 hours (3 days).</li>
                    <li className="mb-2">Each boost uses 10 Credits</li>
                    <li className="mb-2">Boost is only available while the advert is Published</li>
                    <li className="mb-2">Boost limit depends on the advert plan selected during creation.</li>
                </ul>
            </AppDialog>
            <AppDialog
                title={'Boost Advert'}
                open={confirmBoostOpen}
                close={() => setConfirmBoostOpen(false)}
                cancelButton={true}
                positiveTitle={'Boost Advert'}
                positivePress={() => { setConfirmBoostOpen(false); handleSubmit(); }}
                width={'40%'}
            >
                <div>Are you sure you want to boost this advert?</div>
                <div className="my-2">Once boosted,</div>
                <ul className="subheader-2" style={{ padding: 5, paddingInline: 10 }}>
                    <li className="mb-2">Your advert will appear at the top of the marketplace for the next 72 hours.</li>
                    <li className="mb-2">10 Credits will be deducted immediately.</li>
                </ul>
            </AppDialog>
        </React.Fragment>
    )
}